import { Component, OnInit, AfterViewInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
  template: `<div class="login-spin-div">
    <div class="login-content-div"><nz-spin nzTip="正在重定向······"></nz-spin></div>
  </div>`,
  styleUrls:["./style/jzLogin.css"]
})
export class JZCallbackPageComponent implements OnInit {
  constructor(private oauthService: OAuthService, private router: Router) {
  }

  gotoHome(){
    console.log("SSO Callback  返回首页！");
    this.router.navigate(['/']);
  }

  ngOnInit(): void {
    this.oauthService.loadDiscoveryDocumentAndTryLogin()
    .then(_=> {
      this.oauthService.loadUserProfile().then(x=>{
        this.gotoHome();
      }).catch(err =>{
        console.log("获得用户信息出错");
        this.gotoHome();
      })
    }).catch(err =>{
      console.log("根据code换token出错");
      this.gotoHome();
    });
  }

}